"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPasswordHandler = exports.resetPasswordSendEmailHandler = exports.changePasswordHandler = exports.openAuthSessionAsync = exports.handleIntegrationLogin = exports.logOutHandler = exports.verifyEmailHandler = exports.resendVerificationCodeHandler = exports.signUpHandler = exports.loginHandler = void 0;
const account_1 = require("../http/account");
const authStorage_1 = require("../services/authStorage");
const account_2 = require("../store/redux/account");
const utils_1 = require("../services/utils");
const store_1 = require("../store/redux/store");
const native_1 = require("@react-navigation/native");
const config_1 = require("../config/config");
const react_native_1 = require("react-native");
const flight_1 = require("../store/redux/flight");
const message_1 = require("../store/redux/message");
const airport_1 = require("../store/redux/airport");
const loginHandler = (navigation, data) => {
    // TODO: change any to proper type
    (0, account_1.logIn)(data).then(response => {
        const { data } = response;
        (0, authStorage_1.storeAuthItems)(data.access_token, data.refresh_token, data.expire);
        store_1.store.dispatch((0, account_2.authenticateAction)({
            accessToken: data.access_token,
            expDate: String(data.expire),
        }));
        store_1.store.dispatch((0, flight_1.resetFlightState)());
        navigation.dispatch(native_1.CommonActions.navigate({
            name: 'Home',
        }));
    }).catch(error => {
        if (error.status === 400 || error.status === 401 || error.status === 409)
            store_1.store.dispatch((0, account_2.setAccountError)(error.detail));
        if (error.status === 421) {
            store_1.store.dispatch((0, account_2.setAccountError)(error.detail));
            store_1.store.dispatch((0, account_2.setResendVerification)(true));
        }
    });
};
exports.loginHandler = loginHandler;
const signUpHandler = (data, navigation) => {
    (0, account_1.signUp)(data).then(response => {
        if (response.status === 200) {
            navigation.dispatch(native_1.CommonActions.navigate({
                name: react_native_1.Platform.OS === 'web' ? 'SignUpSuccess' : 'Welcome',
            }));
            store_1.store.dispatch((0, account_2.setShowPopup)('verification'));
        }
    }).catch(error => {
        if (error.status === 409)
            store_1.store.dispatch((0, account_2.setAccountError)(error.detail));
        if (error.status === 421) {
            store_1.store.dispatch((0, account_2.setAccountError)(error.detail));
            store_1.store.dispatch((0, account_2.setResendVerification)(true));
        }
    });
};
exports.signUpHandler = signUpHandler;
const resendVerificationCodeHandler = (email, language, navigation) => {
    (0, account_1.resend)(email, language).then(response => {
        if (response.status === 200) {
            navigation.dispatch(native_1.CommonActions.navigate({
                name: react_native_1.Platform.OS === 'web' ? 'LandingPage' : 'Welcome',
            }));
            store_1.store.dispatch((0, account_2.setResendVerification)(false));
            store_1.store.dispatch((0, account_2.setShowPopup)('verification'));
            store_1.store.dispatch((0, account_2.setAccountError)(''));
        }
    }).catch(error => {
        if (error.status === 409)
            store_1.store.dispatch((0, account_2.setResendVerification)(false));
        store_1.store.dispatch((0, account_2.setAccountError)(error.detail));
    });
};
exports.resendVerificationCodeHandler = resendVerificationCodeHandler;
const verifyEmailHandler = async (token, navigation, isMobile = false) => {
    return (0, account_1.verifyEmail)(token).then(response => {
        const { data } = response;
        if (!isMobile) {
            (0, authStorage_1.storeAuthItems)(data.access_token, data.refresh_token, data.expire);
            store_1.store.dispatch((0, account_2.authenticateAction)({
                accessToken: data.access_token,
                expDate: String(data.expire),
                newUser: true
            }));
            navigation.dispatch(native_1.CommonActions.navigate({
                name: 'Home',
            }));
            return null;
        }
        else {
            store_1.store.dispatch((0, account_2.setEmailVerified)(true));
            return { accessToken: data.access_token, expDate: String(data.expire), refreshToken: data.refresh_token };
        }
    }).catch(error => {
        if (error.status === 400 || error.status === 409) {
            store_1.store.dispatch((0, account_2.setShowPopup)(error.detail));
            navigation.dispatch(native_1.CommonActions.navigate({
                name: react_native_1.Platform.OS === 'web' ? 'LandingPage' : 'Welcome',
            }));
        }
        return null;
    });
};
exports.verifyEmailHandler = verifyEmailHandler;
const logOutHandler = () => {
    (0, account_1.logOut)().then(() => {
        store_1.store.dispatch((0, account_2.logoutAction)());
        store_1.store.dispatch((0, flight_1.resetFlightState)());
        store_1.store.dispatch((0, message_1.resetMessagesState)());
        store_1.store.dispatch((0, airport_1.resetAirportState)());
        (0, authStorage_1.clearAuthItems)();
    }).catch(error => {
        console.log(error);
    });
};
exports.logOutHandler = logOutHandler;
const handleIntegrationLogin = (account_type) => {
    const redirectUri = encodeURIComponent(`${config_1.API_URL}account/login/${account_type}/auth`);
    window.location.href = `${config_1.API_URL}account/login/${account_type}?redirect_uri=${redirectUri}`;
};
exports.handleIntegrationLogin = handleIntegrationLogin;
const openAuthSessionAsync = async (accountType, setFunction, WebBrowser, Linking) => {
    try {
        const redirectUri = encodeURIComponent(`${config_1.API_URL}account/login/${accountType}/auth`);
        const app_uri = encodeURIComponent(Linking.createURL());
        const url = `${config_1.API_URL}account/login/${accountType}?redirect_uri=${redirectUri}&app_uri=${app_uri}`;
        let response = await WebBrowser.openAuthSessionAsync(url);
        if (response.type === 'success' && response.url) {
            setFunction(response);
            if (response.url) {
                Linking.parse(response.url);
            }
        }
        else if (response.type === 'cancel') {
            alert('Authentication canceled');
        }
        else if (response.type === 'dismiss') {
            console.log('dismissed');
        }
        else {
            alert(`Authentication error: ${JSON.stringify(response)}`);
        }
    }
    catch (error) {
        alert(error);
        console.log(error);
    }
};
exports.openAuthSessionAsync = openAuthSessionAsync;
const changePasswordHandler = (data, callback, callbackError) => {
    (0, account_1.changePassword)((0, utils_1.convertKeysToSnakeCase)(data)).then(() => {
        callback();
    }).catch(error => {
        if (error.detail === 'password_incorrect' || error.detail === 'password_same')
            store_1.store.dispatch((0, account_2.setAccountError)(error.detail));
        callbackError();
    });
};
exports.changePasswordHandler = changePasswordHandler;
const resetPasswordSendEmailHandler = (data, callback) => {
    (0, account_1.resetPasswordSendEmail)(data).then(() => {
        callback();
    }).catch(error => {
        console.log(error);
    });
};
exports.resetPasswordSendEmailHandler = resetPasswordSendEmailHandler;
const resetPasswordHandler = (data, callback, callbackError) => {
    (0, account_1.resetPasswordChange)(data).then(() => {
        callback();
    }).catch(error => {
        if (error.status === 409)
            store_1.store.dispatch((0, account_2.setAccountError)(error.detail));
        callbackError();
    });
};
exports.resetPasswordHandler = resetPasswordHandler;
